import {
    IntentKind,
    makeIntentBuilderFunction,
    makeIntentGuard,
    type RouteableIntent,
} from '@jet-app/music-classical/intents';

export interface HomePageIntent extends RouteableIntent {
    $kind: IntentKind.HOME_PAGE;
}

export const isHomePageIntent = makeIntentGuard<HomePageIntent>(
    IntentKind.HOME_PAGE,
);
export const makeHomePageIntent = makeIntentBuilderFunction<HomePageIntent>(
    IntentKind.HOME_PAGE,
);
